import { moduleDashboardQuery } from './moduleDashboard'

/**
 * Tabloul de bord al modulelor Softsee, Opteemum si Proactivitee -
 * `GET /api/v2/<modul>/board`.
 *
 * Un singur capat pentru trei module, ca in API (`ModuleBoardController`):
 * ecranul nu se schimba de la un modul la altul, doar felia din catalog.
 *
 * Inventoree are fisierul lui (`api/inventoreeBoard.ts`) fiindca acolo adresa
 * a trebuit sa fie alta, si Easeedesk la fel - nu se rescriu doua capete care
 * merg ca sa incapa intr-un tipar.
 */
export const BOARD_MODULES = ['softsee', 'opteemum', 'proactivitee', 'securitee', 'printeeng', 'protectee'] as const

export type BoardModule = (typeof BOARD_MODULES)[number]

/** Perspectiva, fereastra si clasa de active calatoresc in adresa, ca in portal. */
export function moduleBoardQuery(module: BoardModule, search: string) {
  return moduleDashboardQuery(module, `/${module}/board`, search)
}
